import utils from '../utils/index'
import pannable from '../pannable/index'

import IdManager from '../IdManager/index'

import getProjectionofPointOnLine from '../utils/getProjectionofPointOnLine'

import constants from '../constants/index'

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)

      this["LineLayerMixin@handleClick"] = this["LineLayerMixin@handleClick"].bind(this)
      this["LineLayerMixin@mouseMove"] = this["LineLayerMixin@mouseMove"].bind(this)
      this["LineLayerMixin@mouseDown"] = this["LineLayerMixin@mouseDown"].bind(this)

      this["LineLayerMixin@dblclick"] = this["LineLayerMixin@dblclick"].bind(this)

    }

    createLine(line, silent) {
      let newLine = utils.assign({}, line, {
        id: line.id || IdManager.next()
      })
      newLine.points = this.getPoints(newLine)
      if (silent ? true : this.emit("createLine", newLine)) {
        this.lines = utils.assign({}, this.lines, {
          [newLine.id]: newLine
        })

        return true
      }
      return false
    }

    updateLine(line, silent) {
      if (silent ? true : this.emit("updateLine", line)) {
        this.lines = utils.assign({}, this.lines, {
          [line.id]: utils.assign({}, this.lines[line.id], line)
        })
        return true
      }
      return false
    }

    removeLine(line, silent) {

      if (silent ? true : this.emit("removeLine", line)) {
        if (this.focusObjectId === line.id) {
          this.focusObjectId = null
          this.focusShape(this.shapes[this.lines[line.id].sourceShapeId])
        }
        this.lines = utils.omit(this.lines, [line.id])
        return true
      }
      return false
    }

    focusLine(line, silent) {
      this.selectsObjectIds = {}

      if (silent ? true : this.emit("focusLine", line)) {
        this.focusObjectId = line.id
        return true
      }
      return false
    }

    focusPoint(lineId, index, silent) {
      if (silent ? true : this.emit("focusPoint", lineId, index)) {
        this.focusObjectId = IdManager.join(lineId, index)
        return true
      }
      return false
    }

    removePoint(lineId, index, silent) {
      if (silent ? true : this.emit("removePoint", lineId, index)) {
        this.lines[lineId].points.splice(+index, 1)
        this.lines[lineId].points = this.getPoints(this.lines[lineId])
        this.lines = this.lines

        if (this.focusObjectId === IdManager.join(lineId, index)) {
          this.focusObjectId = null
        }
        return true
      }
      return false
    }

    calcPointsOfSelfConnectLine(shapeId) {
      let shapePos = this.getPointByShape(shapeId)
      return [
        {
          x: shapePos.x,
          y: shapePos.y + shapePos.height / 2
        },
        {
          x: shapePos.x,
          y: shapePos.y + shapePos.height
        },
        {
          x: shapePos.x + shapePos.width,
          y: shapePos.y + shapePos.height
        },
        {
          x: shapePos.x + shapePos.width,
          y: shapePos.y - shapePos.height
        },
        {
          x: shapePos.x,
          y: shapePos.y - shapePos.height
        },
        {
          x: shapePos.x,
          y: shapePos.y - shapePos.height / 2
        }
      ]
    }

    install() {
      super.install()

      let backUpShapeId, pendingPointName, anotherPendingPointName, hasAutoCalcMidPoint

      let onPan = (dx, dy, x, y, e, panningTarget, panOffset) => {
        if (this.panningPointId) {
          let [lineId, index] = IdManager.split(this.panningPointId)
            , frameBx = this.svg.getBoundingClientRect()
            , mousePoint = this.snap(utils.unapplyMatrix(this.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top
            }))
            , points = this.lines[lineId].points
            // check if there is any shape under mouse
            , shape = utils.closest(e.target, ".shape")
          if (shape) {
            if (!(constants.modeFilter.LineReconnect & this.mode)) {
              return
            }
            let [_, shapeId] = IdManager.split(shape.id)
            if (shapeId !== this.lines[lineId][pendingPointName] && shapeId !== this.lines[lineId][anotherPendingPointName]) {
              this.lines[lineId][pendingPointName] = shapeId
              if (hasAutoCalcMidPoint) {
                this.lines[lineId].points = []
              }
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            }

            if (shapeId === this.lines[lineId][anotherPendingPointName]) {
              this.lines[lineId][pendingPointName] = shapeId
              if (this.lines[lineId].points.length <= 2 && !hasAutoCalcMidPoint) {
                this.lines[lineId].points = this.calcPointsOfSelfConnectLine(shapeId)
                hasAutoCalcMidPoint = true
              }
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            }

          } else {
            if (index === "0") {
              // drag source point
              if (!(constants.modeFilter.LineReconnect & this.mode)) {
                return
              }
              this.lines[lineId].sourcePoint = mousePoint
              this.lines[lineId].sourceShapeId = ""
              if (hasAutoCalcMidPoint) {
                this.lines[lineId].points = []
              }
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            } else if (index === points.length - 1 + "") {
              // drag target point
              if (!(constants.modeFilter.LineReconnect & this.mode)) {
                return
              }
              this.lines[lineId].targetPoint = mousePoint
              this.lines[lineId].targetShapeId = ""
              if (hasAutoCalcMidPoint) {
                this.lines[lineId].points = []
              }
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            } else {
              if (!(constants.modeFilter.LinePan & this.mode)) {
                return
              }
              // drag mid point
              this.lines[lineId].points[index] = mousePoint
              if (hasAutoCalcMidPoint) {
                this.lines[lineId].points = []
              }
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            }
          }
          this.requestAutoScroll(e.clientX, e.clientY)
        }
      }, onPanStart = (x, y, e, panningTarget, panOffset) => {
        if (utils.hasClass(panningTarget, "point")) {
          let point = panningTarget
            , [_, lineId, index] = IdManager.split(point.id)
            , frameBx = this.svg.getBoundingClientRect()
            , mousePoint = utils.unapplyMatrix(this.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top
            })
            , points = this.lines[lineId].points.slice(0)

          this.panningPointId = IdManager.join(lineId, index)

          if (index === "0") {
            // drag source point
            if (!(constants.modeFilter.LineReconnect & this.mode)) {
              return
            }
            backUpShapeId = this.lines[lineId].sourceShapeId

            this.lines[lineId].sourcePoint = mousePoint
            this.lines[lineId].sourceShapeId = ""
            this.lines = this.lines
            pendingPointName = "sourceShapeId"
            anotherPendingPointName = "targetShapeId"
          } else if (index === points.length - 1 + "") {
            // drag target point
            if (!(constants.modeFilter.LineReconnect & this.mode)) {
              return
            }
            backUpShapeId = this.lines[lineId].targetShapeId

            this.lines[lineId].targetPoint = mousePoint
            this.lines[lineId].targetPoint = ""
            this.lines = this.lines

            pendingPointName = "targetShapeId"
            anotherPendingPointName = "sourceShapeId"
          } else {
            // drag mid point
            if (!(constants.modeFilter.LinePan & this.mode)) {
              return
            }
            points[index] = mousePoint

            this.lines[lineId].points = points
            this.lines = this.lines
          }

          this.beforeSnap(IdManager.join(lineId, index))
        }

        if (utils.matches(panningTarget, "[data-action^='add-line-']")) {
          let type = panningTarget.getAttribute("data-action").replace(/^add-line-/, '')
            , sourceShape = utils.closest(e.target, ".shape")
            , shapeId = this.focusObjectId
            , frameBx = this.svg.getBoundingClientRect()
            , targetPoint = utils.unapplyMatrix(this.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top
            })
            , line = {
              id: IdManager.next(),
              type,
              sourceShapeId: shapeId,
              targetShapeId: "",
              points: [],

              sourcePoint: { x: -99999, y: -99999 },
              targetPoint,

              isCreateByPan: true
            }
          line.points = this.getPoints(line)

          this.ghostLine = line
        }
      }, onPanEnd = e => {
        if (this.panningPointId) {
          let [lineId, index] = IdManager.split(this.panningPointId)

          if (!this.lines[lineId][pendingPointName]) {
            this.lines[lineId][pendingPointName] = backUpShapeId
            this.lines[lineId].points = this.getPoints(this.lines[lineId])
            this.lines = this.lines
          } else {
            if (!this.updateLine(this.lines[lineId])) {
              this.lines[lineId][pendingPointName] = backUpShapeId
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
              this.lines = this.lines
            }
          }
        }

        if (this.ghostLine && this.ghostLine.isCreateByPan) {
          if (this.ghostLine.targetShapeId) {
            // create
            if (this.createLine(this.ghostLine)) {
              this.focusShape(this.shapes[this.ghostLine.targetShapeId])
              this.ghostLine = null
            }
          } else {
            this.ghostLine = null
          }
        }
        this.afterSnap()
        this["panningPointId"] = ""
        hasAutoCalcMidPoint = false
        this.cancelAutoScroll()
      }

      this["LineLayerMixin@pannableHandler"] = pannable(this.svg, onPan, onPanStart, onPanEnd)

      this.svg.addEventListener("click", this["LineLayerMixin@handleClick"], false)
      this.svg.addEventListener("mousemove", this["LineLayerMixin@mouseMove"], false)
      this.svg.addEventListener("mousedown", this["LineLayerMixin@mouseDown"], false)
      this.svg.addEventListener("dblclick", this["LineLayerMixin@dblclick"], false)
    }

    destroy() {
      super.destroy()

      this["LineLayerMixin@pannableHandler"]()

      this.svg.removeEventListener("click", this["LineLayerMixin@handleClick"], false)
      this.svg.removeEventListener("mousemove", this["LineLayerMixin@mouseMove"], false)
      this.svg.removeEventListener("mousedown", this["LineLayerMixin@mouseDown"], false)
      this.svg.removeEventListener("dblclick", this["LineLayerMixin@dblclick"], false)
    }

    ["LineLayerMixin@handleClick"](e) {
      let btn = utils.closest(e.target, "[data-action^='add-line-']")
      if (btn) {
        let type = btn.getAttribute("data-action").replace(/^add-line-/, '')
          , sourceShape = utils.closest(e.target, ".shape")
          , shapeId = this.focusObjectId
          , frameBx = this.svg.getBoundingClientRect()
          , targetPoint = utils.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top
          })
          , line = {
            id: IdManager.next(),
            type,
            sourceShapeId: shapeId,
            targetShapeId: "",
            points: [],

            sourcePoint: { x: -99999, y: -99999 },
            targetPoint
          }
        line.points = this.getPoints(line)

        this.ghostLine = line
      }

      if (constants.modeFilter.LineFocus & this.mode) {

        let line = utils.closest(e.target, ".line")

        if (line) {
          let [_, lineId] = IdManager.split(line.id)

          this.focusLine(this.lines[lineId])
        }
      }


      let point = utils.closest(e.target, ".point")
      if (point) {
        let [_, lineId, index] = IdManager.split(point.id)

        if (index !== "0" && +index < this.lines[lineId].points.length - 1) {
          this.focusPoint(lineId, index)
        }

      }

      if (utils.closest(e.target, '[data-action="remove-focus-object"]')) {

        if (this.focusObjectId in this.lines) {
          if (this.removeLine(this.lines[this.focusObjectId])) {
          }
        } else {
          // try to parse as a point id
          let [lineId, index] = IdManager.split(this.focusObjectId)

          if (lineId in this.lines) {
            if (index in this.lines[lineId].points) {
              if (index !== "0" && (+index) < this.lines[lineId].points.length - 1) {
                if (this.removePoint(lineId, index)) {
                  this.focusObjectId = null
                }
              }
            }
          }
        }
      }
    }

    ["LineLayerMixin@mouseMove"](e) {
      if (this.ghostLine) {
        let shape = utils.closest(e.target, ".shape")
        if (shape) {
          let [_, shapeId] = IdManager.split(shape.id)
          if (shapeId !== this.ghostLine.targetShapeId && shapeId !== this.ghostLine.sourceShapeId) {
            let ghostLine = utils.assign({}, this.ghostLine, {
              targetShapeId: shapeId,
              points: []
            })
              , points = this.getPoints(ghostLine)
            ghostLine.points = points
            this.ghostLine = ghostLine
          }

          if (shapeId === this.ghostLine.sourceShapeId) {
            let ghostLine = utils.assign({}, this.ghostLine, {
              targetShapeId: shapeId,
              points: this.calcPointsOfSelfConnectLine(shapeId)
            })
              , points = this.getPoints(ghostLine)
            ghostLine.points = points
            this.ghostLine = ghostLine
          }

        } else {
          let frameBx = this.svg.getBoundingClientRect()
            , targetPoint = utils.unapplyMatrix(this.matrix, {
              x: e.clientX - frameBx.left,
              y: e.clientY - frameBx.top
            })
            , ghostLine = utils.assign({}, this.ghostLine, {
              targetPoint,
              targetShapeId: "",
              points: []
            })
            , points = this.getPoints(ghostLine)

          ghostLine.points = points
          this.ghostLine = ghostLine
        }
      }
    }

    ["LineLayerMixin@mouseDown"](e) {
      if (this.ghostLine) {
        if (this.ghostLine.targetShapeId) {
          // create
          if (this.createLine(this.ghostLine)) {
            this.ghostLine = null
          }
        } else {
          this.ghostLine = null
        }
      }
    }

    ["LineLayerMixin@dblclick"](e) {
      if (!(constants.modeFilter.LinePan & this.mode)) {
        return
      }
      let line = utils.closest(e.target, ".line")
      if (line) {
        let [_, lineId] = IdManager.split(line.id)
          , frameBx = this.svg.getBoundingClientRect()
          , mousePoint = utils.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top
          })
          , pointOnLine = getProjectionofPointOnLine(mousePoint, this.lines[lineId].points)
          , points = this.lines[lineId].points.slice(0);
        if (pointOnLine) {
          points.splice(pointOnLine.i + 1, 0, mousePoint)
          this.lines[lineId].points = points
          this.lines = this.lines
        }

      }
    }

    getPoints({
      sourceShapeId,
      targetShapeId,
      points,

      sourcePoint,
      targetPoint
    }) {
      // 1, sourceShapeId, targetShapeId, points.length > 2
      if (sourceShapeId && targetShapeId && points.length > 2) {
        let inpa = this.getIntersetion(points[1], sourceShapeId)
          , inpb = this.getIntersetion(points[points.length - 2], targetShapeId)

        if (inpa && inpb) {
          return [inpa, ...points.slice(1, points.length - 1), inpb];
        }
        return [];
      }

      // 2. sourceShapeId, !targetShapeId, points.length > 2
      if (sourceShapeId && !targetShapeId && points.length > 2 && targetPoint) {
        let inpa = this.getIntersetion(points[1], sourceShapeId)
        if (inpa) {
          return [inpa, ...points.slice(1, points.length - 1), targetPoint];
        }
        return [];
      }

      // 3. !sourceShapeId, targetShapeId, points.length > 2
      if (!sourceShapeId && targetShapeId && points.length > 2 && sourcePoint) {
        let inpb = this.getIntersetion(points[points.length - 2], targetShapeId)
        if (inpb) {
          return [sourcePoint, ...points.slice(1, points.length - 1), inpb];
        }
        return [];
      }

      // 4. !sourceShapeId, !targetShapeId, points.length > 2
      if (!sourceShapeId && !targetShapeId && points.length > 2) {
        return [];
      }

      // 5. sourceShapeId, targetShapeId, points.length <= 2
      if (sourceShapeId && targetShapeId && points.length <= 2) {
        let inpa = this.getIntersetion(sourceShapeId, targetShapeId)
          , inpb = this.getIntersetion(targetShapeId, sourceShapeId)

        if (inpa && inpb) {
          return [inpa, inpb];
        }
        return [];
      }

      // 6. sourceShapeId, !targetShapeId, points.length <= 2
      if (sourceShapeId && !targetShapeId && points.length <= 2) {
        let inpa = this.getIntersetion(sourceShapeId, targetPoint)

        if (inpa) {
          return [inpa, targetPoint];
        }
        return [];
      }

      // 7. !sourceShapeId, targetShapeId, points.length <= 2
      if (!sourceShapeId && targetShapeId && points.length <= 2) {
        let inpb = this.getIntersetion(sourcePoint, targetShapeId)


        if (inpb) {
          return [sourcePoint, inpb];
        }
        return [];
      }

      // 8. !sourceShapeId, !targetShapeId, points.length <= 2
      if (!sourceShapeId && !targetShapeId && points.length <= 2) {
        return [];
      }
    }

    getIntersetion(source, target) {
      let line = this.getLine(source, target)
        , curve = this.getCurve(source, target)
        // @ts-ignore
        , int = Snap.path.intersection(line, curve)
      if (int && int.length) {
         return int[0]
      }


      if (typeof source === "string") {
        return this.getPointByShape(source)
      } else if (typeof target === "string") {
        return this.getPointByShape(target)
      }
      return null
    }

    getLine(source, target) {
      let p1, p2;
      if (typeof source === "string") {
        p1 = this.getPointByShape(source)
      } else {
        p1 = source
      }

      if (typeof target === "string") {
        p2 = this.getPointByShape(target)
      } else {
        p2 = target
      }

      return `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y}`
    }

    getLineDefByType(type) {
      return this.lineDefs[type] || this.lineDefs[Object.keys(this.lineDefs)[0]]
    }

    getPointByShape(shapeId) {
      let shape = this.shapes[shapeId]
        , { type, matrix } = shape
        , { bbox } = this.getShapeDefByType(type)
        , width= shape.type==='normal'?utils.getTextLen(shape.name):bbox.width
        // @ts-ignore
        , ctm = (Snap.matrix(...matrix)).translate(-(bbox.x + width / 2), -(bbox.y + bbox.height / 2))
        , mid = {
          x: bbox.x + width / 2,
          y: bbox.y + bbox.height / 2
        }
        , tmid = utils.applyMatrix([ctm.a, ctm.b, ctm.c, ctm.d, ctm.e, ctm.f], mid)
        , ttopLeft = utils.applyMatrix([ctm.a, ctm.b, ctm.c, ctm.d, ctm.e, ctm.f], bbox)
      tmid.width = 2 * (tmid.x - ttopLeft.x)
      tmid.height = 2 * (tmid.y - ttopLeft.y)
      return tmid
    }

    getCurve(source, target) {
      let shapeId
      if (typeof source === "string") {
        shapeId = source
      } else {
        shapeId = target
      }

      let shape = this.shapes[shapeId]
        , { type, matrix } = shape
        , { bbox, path } = this.getShapeDefByType(type)
        , width= utils.isRectNode(shape)?utils.getTextLen(shape.name):bbox.width;
      if (bbox.path && utils.isRectNode(shape)) {
        path=MW.deepClone(bbox.path);
        path[1][1]=width;
        path[3][1]=-width;
      }
        // @ts-ignore
         let ctm = (Snap.matrix(...matrix)).translate(-(bbox.x+width / 2), -(bbox.y+bbox.height / 2));
        //, ctm = (Snap.matrix(...matrix)).translate(0, 0)
      // @ts-ignore
      return Snap.path.map(path, ctm)
    }

    addLine(type, name, style, focusStyle) {
      this.lineDefs[type] = {
        type,
        name,
        style,
        focusStyle
      }
      this.lineDefs = this.lineDefs
    }
    getBBox(points, hotAreaWidth = 15) {
      if (points.length) {
        let xmin = points[0].x
          , ymin = points[0].y
          , xmax = xmin
          , ymax = ymin;
        for (let i = 0; i < points.length; i++) {
          xmin = Math.min(points[i].x, xmin);
          ymin = Math.min(points[i].y, ymin);
          xmax = Math.max(points[i].x, xmax);
          ymax = Math.max(points[i].y, ymax);
        }

        return {
          x: xmin - hotAreaWidth / 2,
          y: ymin - hotAreaWidth / 2,
          width: xmax - xmin + hotAreaWidth,
          height: ymax - ymin + hotAreaWidth
        }
      }
      return { x: 0, y: 0, width: 0, height: 0 }
    }

    getTotalLengthOfPoint(points) {
      // @ts-ignore
      return Snap.path.getTotalLength(`M ${points[0].x} ${points[0].y} ${points.slice(1).map(({ x, y }) => `L ${x} ${y}`).join("")}`)
    }

    getPanningLineHtml() {
      if (this.panningGroup && !utils.isEmpty(this.panningGroup.lines)) {
        let { panStartPoint, panEndPoint } = this.panningGroup
          , dx = panEndPoint.x - panStartPoint.x
          , dy = panEndPoint.y - panStartPoint.y

        return Object.keys(this.panningGroup.lines).map(lineId => {
          let { type, points, id, sourceShapeId, targetShapeId } = this.lines[lineId]
            , { style, focusStyle } = this.getLineDefByType(type)
          return `
            <polyline 
            points="${points.map(({ x, y }) => `${x + dx} ${y + dy}`).join(",")}"
            ${Object.keys(style).map(name => `${name}="${style[name]}"`).join(" ")}
            pointer-events="none"
            stroke="rgb(255, 195, 66)"
            stroke-width=2
          ></polyline>
          `
        }).join("")
      }
      return ""
    }

    renderOneLine(line, isGhost) {
      let { type, points, id, sourceShapeId, targetShapeId, tip = '' } = line
        , { style, focusStyle } = this.getLineDefByType(type)
        , focusedPointIndex = this.focusObjectId && +this.focusObjectId.replace(new RegExp(`^${id}:(\\d+)$`, "g"), "$1")
        , focus = this.focusObjectId === id
        , semifocus = typeof focusedPointIndex === "number"
        , bbox = this.getBBox(points)
        , muted = isGhost || this.panningPointId || !(focus || semifocus)
        , ps = points.map(({ x, y }) => `${x} ${y}`).join(",")
        , startDash = 10
        , endDash = 10
        , lineLength = this.getTotalLengthOfPoint(points)
        , midDash = lineLength - startDash - endDash
        , canReconnect = constants.modeFilter.LineReconnect & this.mode
        , start = canReconnect ? 0 : 1
        , end = canReconnect ? void 0 : -1
        , opacity = 0

        , midPoint = Snap.path.getPointAtLength(`M ${points[0].x} ${points[0].y} ${points.slice(1).map(({ x, y }) => `L ${x} ${y}`).join("")}`, lineLength / 2)
        , tipLite = tip.replace(/(.{7}).*/g, '$1...');

      if (this.panningGroup && ((sourceShapeId in this.panningGroup.shapes) || (targetShapeId in this.panningGroup.shapes))) {
        opacity = .5
      }


      if (focus) {
        style = utils.assign({}, style, focusStyle)
      }

      return `
      <g
        id="${IdManager.join(this.id, id)}"
        class="line"
      >
        <polyline 
          points="${ps}"
          fill="none"
          stroke="transparent"
          stroke-opacity="0"
          stroke-width="10"
          pointer-events="${isGhost ? "none" : "auto"}"
        ></polyline>
        <polyline 
          points="${ps}"
          fill="none"
          stroke="#fff"
          stroke-opacity="0.9"
          stroke-dasharray="${startDash} ${midDash} ${endDash}"
          stroke-dashoffset="${startDash + midDash + endDash}"
          stroke-width="${6}"
          pointer-events="none"
        ></polyline>
        <polyline 
          points="${ps}"
          ${Object.keys(style).map(name => `${name}="${style[name]}"`).join(" ")}
          pointer-events="none"
          ${opacity ? `style=opacity:${opacity}` : ``}
        ></polyline>

        ${points.slice(start, end).map(({ x, y }, i) => `
          <circle 
            cx="${x}" 
            cy="${y}" 
            r="5" 
            fill="${focusedPointIndex === (i + start) ? "red" : "#000"}" 
            pointer-events="${muted ? "none" : "all"}"
            fill-opacity="${focusedPointIndex === (i + start) ? "1" : ".3"}" 
            stroke="transparent" 
            stroke-width="10" 
            id="${IdManager.join(this.id, id, i + start)}" 
            class="point pannable"
            visibility="${(focus || focusedPointIndex) && (constants.modeFilter.LinePan & this.mode) ? "visible" : "hidden"}"
            ></circle>
        `).join("")}

        <rect
          x = "${bbox.x}"
          y = "${bbox.y}"
          width = "${bbox.width}"
          height = "${bbox.height}"
          fill="none" 
          stroke="#8888FF" 
          stroke-dasharray="3,3"
          shape-rendering = "crispEdges"
          visibility="${focus ? "visible" : "hidden"}"
          pointer-events = "none"
        >
        </rect>
        <title>${tip || ''}</title>
        <g>
          <text style="cursor: default;" x=${midPoint.x} y=${midPoint.y} text-anchor=middle filter=url(#${IdManager.join(this.id, "screenBlendMode")} font-size=11>
            <tspan>${tipLite || ''}</tspan>
            <title>${tip || ''}</title>
          </text>
        </g>
      </g>
      `
    }

    display() {
      let linesHtml = Object.keys(this.lines).map(lineId => lineId === this.focusObjectId ? "" : this.renderOneLine(this.lines[lineId])).join("")
        , ghostLineHtml = this.ghostLine
          ? this.renderOneLine(this.ghostLine, true)
          : ""
        , focusLineHtml = this.focusObjectId in this.lines ? this.renderOneLine(this.lines[this.focusObjectId]) : ""
        , panningLineHtml = this.getPanningLineHtml()
      return super.display() + `<g>${linesHtml}${ghostLineHtml}${focusLineHtml}</g><g>${panningLineHtml}</g>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/LineLayerMixin.js